import { Component, inject, input } from '@angular/core';
import { AdvertViewModel } from '@models/advert/advert';
import { CountryService } from '@services/country.service';
import { TranslateModule } from '@ngx-translate/core';
import { NumeralPipe } from '../../../../pipes/numeral.pipe';
import { ConvertDatePipe } from '@pipes/convert-date.pipe';

@Component({
    selector: 'apartment-stats',
    templateUrl: './apartment-stats.component.html',
    imports: [TranslateModule, NumeralPipe, ConvertDatePipe]
})
export class ApartmentStatsComponent {
    private countryService = inject(CountryService);

    isLettableDateEnabled: boolean = this.countryService.getCurrentCountry() === 'FR';

    readonly advert = input<AdvertViewModel>(undefined);
}
